import ReservedValue, {TReservedValue} from '../Constants/ReservedValue';

const createNextValue = (previousValue: string, keyValue: TReservedValue | string): string => {
    switch (keyValue) {
        case ReservedValue.SPACE:
            return previousValue + ' ';
        case ReservedValue.BACKSPACE:
            return previousValue.slice(0, previousValue.length - 1);
        default:
            return previousValue + keyValue;
    }
};

export default createNextValue;
